<template>
  <transition name="fade">
    <div class="modal" id="message-box" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="handleAction('cancel')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ title }}</h4>
          </div>
          <div class="modal-body">
            <p ref="content">{{ content }}</p>
          </div>
          <div class="modal-footer" v-if="type == 'alert'">
            <button
              v-if="showAlertBtn"
              type="button"
              class="btn btn-primary"
              @click="handleAction('cancel')"
            >
              {{ alertBtnText }}
            </button>
          </div>
          <div class="modal-footer" v-if="type == 'confirm'">
            <button
              v-if="showCancleBtn"
              type="button"
              class="btn btn-default"
              @click="handleAction('cancel')"
            >
              {{ cancelBtnText }}
            </button>
            <button
              v-for="(item, index) in custom"
              :key="index"
              type="button"
              class="btn btn-primary"
              @click="handleAction(item.action)"
            >
              {{ item.btnText }}
            </button>
            <button
              v-if="showYesBtn"
              type="button"
              class="btn btn-primary"
              @click="handleAction('yes')"
            >
              {{ yesBtnText }}
            </button>
            <button
              v-if="showCopyBtn"
              type="button"
              class="btn btn-primary"
              @click="copy"
            >
              {{ copyBtnText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Confirm",
  props: {
    title: {
      type: String,
      default: "提示",
    },
    content: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "confirm",
    },
    showAlertBtn: {
      type: Boolean,
      default: false,
    },
    alertBtnText: {
      type: String,
      default: "我知道了",
    },
    showCopyBtn: {
      type: Boolean,
      default: false,
    },
    copyBtnText: {
      type: String,
      default: "复制",
    },
    showYesBtn: {
      type: Boolean,
      default: true,
    },
    yesBtnText: {
      type: String,
      default: "确定",
    },
    showCancleBtn: {
      type: Boolean,
      default: true,
    },
    cancelBtnText: {
      type: String,
      default: "取消",
    },
    custom: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      promiseStatus: null,
    };
  },
  methods: {
    copy() {
      let container = this.$refs.content;
      this.$copyText(this.content, container)
        .then(() => {
          this.copyBtnText = "已复制";
        })
        .catch(() => {
          this.copyBtnText = "复制失败";
          alert("复制失败，建议您手动复制文字");
        });
      setTimeout(() => {
        this.copyBtnText = "复制文字";
      }, 2000);
    },
    confirm() {
      let that = this;
      $("#message-box").modal("show");
      return new Promise(function (resolve, reject) {
        that.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      if (action !== "copy") {
        $("#message-box").modal("hide");
      }
      if (action == "cancel") {
        this.promiseStatus && this.promiseStatus.reject();
      } else {
        this.promiseStatus && this.promiseStatus.resolve(action);
      }
    },
  },
  destroyed() {},
};
</script>

<style scoped>
</style>